<template>
    <section class="video-bg">
        <video id="bgvid" class="background-video hero-bg-video is-playing" autoplay loop muted playsinline webkit-playinginline>
            <source src="/assets/bre3/videos/dominart.mp4" type="video/mp4">
            <source src="/assets/bre3/videos/dominart.webm" type="video/webm">
            <source src="/assets/bre3/videos/dominart.ogv" type="video/ogg">
        </video>

        <div class="video-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-11 offset-lg-1">
                        <div class="d-flex align-items-center justify-content-between">
                            <h1>{{ title }}</h1>
                            <div>
                                <a href="#" class="video-play-pause" @click="onPlayPause">
                                    <div>
                                        <font-awesome-icon :icon="['fa', 'pause']" v-if="isPLaying"></font-awesome-icon>
                                        <font-awesome-icon :icon="['fa', 'play']" v-else></font-awesome-icon>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <ul>
                            <li v-for="(subTitle, index) in subTitles" :key="index">{{ subTitle }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { defineComponent } from 'vue';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    require('../font-awesome');

    export default defineComponent({
        name: 'BgVideo',
        components: {
            FontAwesomeIcon,
        },
        data() {
            return {
                isPLaying: false,
            };
        },
        methods: {
            onPlayPause() {
                this.isPLaying = !this.isPLaying;
                document.getElementById('bgvid')[this.isPLaying ? 'play' : 'pause']();
            },
        },
        mounted() {
            this.onPlayPause();
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            subTitles: {
                type: Array,
                default: () => [],
            },
        },
    });
</script>

<style scoped>

</style>
